// Import de funcions auxiliars
import {
    obteVariable,
    obteValorVariable,
    afegeixErrorAVariable
}  from './utils';

/*
 * Per facilitar la lectura del codi s'afegeixen els identificadors de variables a mode de constants
 * NOTA: La variable 17 també està definida com a velocitat de vent, però es va donar de baixa el dia 01/05/2011-05
 *       Donat que aquest filtres s'apliquen per la introducció de dades noves amb un màxim de 30 dies abans,
 *       només es controlarà la nova variable de velocitat de vent (la 83).
 ***/
export const ID_VELOCITAT_DEL_VENT = 83;
export const ID_DIRECCIO_DEL_VENT = 18;

//El valor 211 de la variable velocitat del vent està associat a l'etiqueta "0" a la BBDD
export const VALOR_VELOCITAT_VENT_ETIQUETA_0 = '211';

//El valor 18 de la variable direcció del vent està associat a l'etiqueta "CAL" (calma) a la BBDD
export const VALOR_DIRECCIO_VENT_ETIQUETA_CAL = '18';

/*
 * Missatges d'error propis del grup
 ***/

export const MSG_SI_VEL_VENT_INFORMAT_ALESHORES_DIREC_VENT_OBLIGATORIA = 'Si s\'ha informat la velocitat del vent, s\'ha d\'informar la direcció del vent.';
export const MSG_SI_DIREC_VENT_INFORMAT_ALESHORES_VEL_VENT_OBLIGATORIA = 'Si s\'ha informat la direcció del vent, s\'ha d\'informar la velocitat del vent.';

export const MSG_SI_VEL_VENT_SUPERIOR_0_ALESHORES_DIREC_VENT_DIFERENT_DE_CALMA = 'Si la velocitat del vent és superior a zero, s\'ha d\'informar una direcció del vent diferent a CAL (calma).';

/*
 * Funcions auxiliars que ajuden a la legibilitat
 ***/

const checkSiVelVentNoNulDirecVentNoNul = (velocitatDelVentValor, direccioDelVentValor) => {
    return velocitatDelVentValor !== null && direccioDelVentValor === null;
};

const checkSiDirecVentNoNulVelVentNoNull = (velocitatDelVentValor, direccioDelVentValor) => {
    return direccioDelVentValor !== null && velocitatDelVentValor === null;
};

const checkSiVelVentSuperior0DirecVentDiferentDeCalma = (velocitatDelVentValor, direccioDelVentValor) => {
    return velocitatDelVentValor !== VALOR_VELOCITAT_VENT_ETIQUETA_0 && direccioDelVentValor === VALOR_DIRECCIO_VENT_ETIQUETA_CAL;
};

/*
 * Grup Vent
 ***/
export const checkGrupVent = (nouVariables) => {

    // Variables
    const velocitatDelVent = obteVariable(ID_VELOCITAT_DEL_VENT, nouVariables);
    const direccioDelVent = obteVariable(ID_DIRECCIO_DEL_VENT, nouVariables);

    if (!velocitatDelVent || !direccioDelVent) {
        return;
    }

    // Valors de variables
    const velocitatDelVentValor = obteValorVariable(velocitatDelVent);
    const direccioDelVentValor = obteValorVariable(direccioDelVent);

    // Si VELOCITAT_DEL_VENT informada aleshores DIRECCIO_DEL_VENT ha de ser informada
    if (checkSiVelVentNoNulDirecVentNoNul(velocitatDelVentValor, direccioDelVentValor)) {
        afegeixErrorAVariable(direccioDelVent, MSG_SI_VEL_VENT_INFORMAT_ALESHORES_DIREC_VENT_OBLIGATORIA);
        afegeixErrorAVariable(velocitatDelVent, MSG_SI_VEL_VENT_INFORMAT_ALESHORES_DIREC_VENT_OBLIGATORIA);
        return;
    }

    // Si DIRECCIO_DEL_VENT aleshores VELOCITAT_DEL_VENT ha de ser informada
    if (checkSiDirecVentNoNulVelVentNoNull(velocitatDelVentValor, direccioDelVentValor)) {
        afegeixErrorAVariable(direccioDelVent, MSG_SI_DIREC_VENT_INFORMAT_ALESHORES_VEL_VENT_OBLIGATORIA);
        afegeixErrorAVariable(velocitatDelVent, MSG_SI_DIREC_VENT_INFORMAT_ALESHORES_VEL_VENT_OBLIGATORIA);
        return;
    }

    // Si VELOCITAT_DEL_VENT > 0 aleshores DIRECCIO_DEL_VENT !== (calma)
    if (checkSiVelVentSuperior0DirecVentDiferentDeCalma(velocitatDelVentValor, direccioDelVentValor)) {
        afegeixErrorAVariable(direccioDelVent, MSG_SI_VEL_VENT_SUPERIOR_0_ALESHORES_DIREC_VENT_DIFERENT_DE_CALMA);
        afegeixErrorAVariable(velocitatDelVent, MSG_SI_VEL_VENT_SUPERIOR_0_ALESHORES_DIREC_VENT_DIFERENT_DE_CALMA);
    }

};



// WEBPACK FOOTER //
// ./src/reducers/observacio/formulari/filtresCoherencia/grupVent.js